export const btsData = [
  {
    id: 180,
    path: ["69.131.176.185", "186.1.43.90", "86.108.103.180", "43.27.66.183"],
    content: "to satelit",
    from: "69.131.176.185",
    to: "43.27.66.183",
    speed: 20,
  },
];
